module.exports = __webpack_public_path__ + "static/img/3.b699478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/3.png
// module id = IUjK
// module chunks = 0